<h6 [innerHtml]="container.title | translateLabel"></h6>
<ng-container *ngFor="let question of container?.questions">
    <app-question-component *ngIf="showQuestion(question)" [group]="group" [question]="question"></app-question-component>
</ng-container>
